import APP from './app.json';

export const SERVER = APP.SERVER;
export const CLIENT = APP.CLIENT;
export const METRIKA = APP.METRIKA;